import { atom } from 'jotai';

export const uiStateAtomAddProfessionalModalOpened = atom(false);
